import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { koKR } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface IProps {
  value: string | undefined;
  onChange: (value: string) => void;
}
const MapTimePicker = ({ value, onChange }: IProps) => {
  const [curTime, setCurTime] = useState('');

  const onChangeInput = (value: any | unknown) => {
    if (!value) {
      return;
    }
    const hour = value.$H;
    const changedHour = hour < 10 ? `0${hour}` : hour;
    const minute = value.$m;
    const changedMinute = minute < 10 ? `0${minute}` : minute;
    onChange(`${changedHour}:${changedMinute}`);
  };

  useEffect(() => {
    if (value !== undefined) {
      setCurTime(value);
    }
  }, [value]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={koKR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <CustomTimeField
        format="hh:mm A"
        value={dayjs(curTime === '' ? undefined : curTime)}
        onChange={(newValue) => {
          onChangeInput(newValue);
        }}
      />
    </LocalizationProvider>
  );
};
const CustomTimeField = styled(MobileTimePicker)`
  display: flex;
  justify-content: center;

  .MuiInputBase-root {
    width: 100px;
    height: 30px;
    bottom: 0;
    border-radius: 0.3125rem;
    background: #006ac8;
    border: none;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
    :focus {
      outline: 0;
    }
  }
  .MuiOutlinedInput-root fieldset {
    border: 0;
  }
  .MuiOutlinedInput-input {
    text-align: center;
  }
`;

export default MapTimePicker;
